const scriptUrls = [
    'https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@4.22.0/dist/tf.min.js',
    'https://cdn.jsdelivr.net/npm/@tensorflow-models/mobilenet@2.1.1/dist/mobilenet.min.js',
    'https://cdn.jsdelivr.net/npm/@tensorflow-models/knn-classifier@1.2.2/dist/knn-classifier.min.js'
];

let librariesPromise = null;

const loadScript = url => new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-vision-lib="${url}"]`);
    if (existing) {
        if (existing.dataset.loaded === 'true') {
            resolve();
            return;
        }
        existing.addEventListener('load', resolve, {once: true});
        existing.addEventListener('error', reject, {once: true});
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = url;
    script.dataset.visionLib = url;
    script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve();
    }, {once: true});
    script.addEventListener('error', () => reject(new Error(`Failed to load ${url}`)), {once: true});
    document.head.appendChild(script);
});

const loadVisionLibraries = () => {
    if (!librariesPromise) {
        librariesPromise = scriptUrls.reduce(
            (promise, url) => promise.then(() => loadScript(url)),
            Promise.resolve()
        ).then(() => {
            if (!window.tf || !window.mobilenet || !window.knnClassifier) {
                throw new Error('Vision libraries were loaded but not attached to window.');
            }

            return {
                tf: window.tf,
                mobilenet: window.mobilenet,
                knnClassifier: window.knnClassifier
            };
        });
    }

    return librariesPromise;
};

export default loadVisionLibraries;
